module.exports = "<span class=\"padding-10\">\n  <em class=\"badge padding-5 no-border-radius bg-color-blueLight pull-left margin-right-5\">\n    <i [ngClass]=\"setClasses()\"></i>\n  </em>\n  <span>{{item.message}}<br/>\n    <span class=\"pull-right font-xs text-muted\"><i>{{item.time}}</i></span>\n  </span>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/header/activities/activities-notification/activities-notification.component.html
// module id = ./src/app/shared/layout/header/activities/activities-notification/activities-notification.component.html
// module chunks = main